import React from 'react';
import { ArrowIconType } from '../../domains/common';

interface IArrowIcon {
  type: ArrowIconType;
  fill?: string;
}

const ArrowIcon: React.FC<IArrowIcon> = props => {
  const { type, fill } = props;
  if (type === ArrowIconType.LEFT) {
    return (
      <svg width="1em" height="1em" viewBox="0 0 10 10" fill="none">
        <path
          d="M4.85731 9.256L5.75331 8.248L2.96931 5.704H9.32131V4.232H2.96931L5.75331 1.688L4.85731 0.679999L0.457312 4.936V5L4.85731 9.256Z"
          fill={fill || 'white'}
        />
      </svg>
    );
  }
  return (
    <svg width="1em" height="1em" viewBox="0 0 10 10" fill="none">
      <path
        d="M5.14269 9.256L4.24669 8.248L7.03069 5.704H0.678688V4.232H7.03069L4.24669 1.688L5.14269 0.679999L9.54269 4.936V5L5.14269 9.256Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export default ArrowIcon;
